import PageHero from "@/components/shared/PageHero";
import AwardsSection from "@/components/sections/AwardsSection";
import CTASection from "@/components/sections/CTASection";
import { ASSETS, BRAND } from "@/lib/brand";

export default function AwardsPage() {
  return (
    <div data-testid="page-awards">
      <PageHero
        eyebrow="Awards & Recognition"
        title={<>Quietly recognized — <span className="italic text-bronze">consistently.</span></>}
        sub="Industry awards are a byproduct of doing right by clients. A few highlights from the A Homely Abode journey."
        image={ASSETS.lifestyle.bronzeTexture}
        ctas={[
          { label: "Start Your Journey", href: BRAND.whatsapp, variant: "primary" },
          { label: "Read Testimonials", to: "/success-stories/testimonials", variant: "secondary" },
        ]}
      />
      <AwardsSection withHeading={false} background="bg-cream" />
      <CTASection />
    </div>
  );
}
